import React, { useState, useEffect } from "react";
import {
    Grid,
    Tab,
    Tabs,
} from "@material-ui/core";
import useStyles from "./styles";
import Loader from "../../components/Loader/Loader";
import Breadcrums from "../../components/BreadCrums/breadcrums";
import { withSnackbar } from "./../../components/Message/Alert";
import TopSpacer from '../../components/Common/spacer/TopSpacer';
import AgencyList from "./components/agencyList/AgencyList";
import DistributerList from "./components/distributerList/DistributerList";
import PressRelease from "./components/PressRelease/PressRelease";
import { GetUserRolesRights } from '../../Services/GetUserRolesRights';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>{children}</>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function CorporateManagement({ isPostpaid, isPinCodeVerified, ...props }) {
    const classes = useStyles();
    const [state, setState] = useState({ accounts: "" });
    const [isLoading, setIsLoading] = useState(false);

    const [tabvalue, setTabValue] = useState(null); 

    const onTabChange = (e, newValue) => {
        debugger
        setTabValue(newValue);
    };


    let user_role_rights_list = JSON.parse(GetUserRolesRights());

    const hasAgencyListRight = user_role_rights_list.some(item => item.rightCode === "AgencyList" && item.permissionCode === 2);
    const hasDistributerList = user_role_rights_list.some(item => item.rightCode === "DistributerList" && item.permissionCode === 2);
    const hasPressRelease = user_role_rights_list.some(item => item.rightCode === "PressRelease" && item.permissionCode === 2);
    useEffect(() => {
        if (hasAgencyListRight) {
            setTabValue("Agency List");
        } else if (hasDistributerList) {
            setTabValue("Distribution List");
        } else if (hasPressRelease) {
            setTabValue("Press Release");
        }        
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>

                        <Breadcrums parentLink={"News Media"} currentLink={tabvalue === "Agency List" ? "Agency List" : tabvalue === "Distribution List" ? "Distribution List" : tabvalue === "Press Release" ? "Press Release" : ""} isBack={false}></Breadcrums>
                    </Grid>
                </Grid>
            </div>
            <div className={classes.tabarea}>
                <div className={classes.tabPan}>
                    <div className={classes.tabsSection}>
                        <Tabs

                            value={tabvalue}
                            onChange={onTabChange}
                            aria-label="icon tabs example"
                            variant="scrollable"
                            scrollButtons={true}
                            className={classes.Htabs}
                            allowScrollButtonsMobile
                        >

                            {hasAgencyListRight && (<Tab label="Agency List" value="Agency List" aria-label="Agency List" {...a11yProps(0)} />)}
                            {hasDistributerList && (<Tab label="Distribution List" value="Distribution List" aria-label="Distribution List" {...a11yProps(1)} />)}
                            {hasPressRelease && (<Tab label="Press Release" value="Press Release" aria-label="Press Release" {...a11yProps(2)} />)}


                        </Tabs>
                    </div>
                </div>
                {hasAgencyListRight && (<TabPanel value={tabvalue} index={"Agency List"} className={classes.tabPan}>
                    {tabvalue === "Agency List" ?
                        <AgencyList></AgencyList>
                        : null}
                </TabPanel>)}


                {hasDistributerList && (<TabPanel value={tabvalue} index={"Distribution List"} className={classes.tabPan}>
                    {tabvalue === "Distribution List" ?
                        <DistributerList></DistributerList>

                        : null}

                </TabPanel>)}
                {hasPressRelease && (<TabPanel value={tabvalue} index={"Press Release"} className={classes.tabPan}>
                    {tabvalue === "Press Release" ?
                        <PressRelease></PressRelease>

                        : null}

                </TabPanel>)}

            </div>


        </>
    )
}
export default withSnackbar(CorporateManagement);
